import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { createOptionsList } from '../../../../../services/common/miscUtils';
import { IncomeFrequencyEnum, MaritalStatusEnum, TitleEnum } from '../../../../../types/forms';
import { NumericInputFormField } from '../../../../Fieldset/NumericInputFormField';
import { PhoneNumberFormField } from '../../../../Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../../../Fieldset/TextInputFormField';
import { buildFieldName } from '../../../../../utils/fieldNameUtils';

export const createFormInputs = (formTranslationKey: string, disabled = false, fieldNamePrefix?: string) => {
  return {
    title: () => (
      <SelectFormField
        fieldName="title"
        labelTranslationKey={`${formTranslationKey}:fields:title:label`}
        optionList={createOptionsList(TitleEnum, formTranslationKey, 'title')}
        isDisabled={disabled}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName="firstName"
        labelTranslationKey={`${formTranslationKey}:fields:firstName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:firstName:placeholder`}
        isDisabled={disabled}
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName="lastName"
        labelTranslationKey={`${formTranslationKey}:fields:lastName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:lastName:placeholder`}
        isDisabled={disabled}
      />
    ),
    middleName: () => (
      <TextInputFormField
        fieldName="middleName"
        optional
        labelTranslationKey={`${formTranslationKey}:fields:middleName:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:middleName:placeholder`}
        isDisabled={disabled}
      />
    ),
    maritalStatus: () => (
      <SelectFormField
        fieldName="maritalStatus"
        labelTranslationKey={`${formTranslationKey}:fields:maritalStatus:label`}
        optionList={createOptionsList(MaritalStatusEnum, formTranslationKey, 'maritalStatus')}
        isDisabled={disabled}
      />
    ),
    netMonthlyIncome: () => (
      <NumericInputFormField
        fieldName="netMonthlyIncome"
        labelTranslationKey={`${formTranslationKey}:fields:netMonthlyIncome:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:netMonthlyIncome.placeholder`}
        isDisabled={disabled}
        type="money"
      />
    ),
    incomeFrequency: () => (
      <SelectFormField
        fieldName="incomeFrequency"
        labelTranslationKey={`${formTranslationKey}:fields:incomeFrequency:label`}
        optionList={createOptionsList(IncomeFrequencyEnum, formTranslationKey, 'incomeFrequency')}
        isDisabled={disabled}
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName={buildFieldName('countryCode', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:countryCode:label`}
        optionList={createOptionsList(PhoneCountryCodeType, formTranslationKey, 'countryCode')}
        isDisabled={disabled}
      />
    ),
    phoneNumber: () => (
      <PhoneNumberFormField
        fieldName={buildFieldName('phoneNumber', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:phoneNumber:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:phoneNumber:placeholder`}
        isDisabled={disabled}
        type="mobile"
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName={buildFieldName('email', fieldNamePrefix)}
        labelTranslationKey={`${formTranslationKey}:fields:email:label`}
        placeholderTranslationKey={`${formTranslationKey}:fields:email:placeholder`}
        isDisabled={disabled}
      />
    ),
  };
};
